import Icon from '../../../components/AppIcon';

const StatsCard = ({ stat }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <div className={`w-10 h-10 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
          <Icon name={stat?.icon} size={20} color={stat?.iconColor} />
        </div>
        {stat?.trend && (
          <div className={`flex items-center gap-1 text-xs font-medium ${stat?.trendUp ? 'text-success' : 'text-error'}`}>
            <Icon name={stat?.trendUp ? 'TrendingUp' : 'TrendingDown'} size={14} />
            <span>{stat?.trend}</span>
          </div>
        )}
      </div>
      <div className="text-2xl font-bold text-foreground mb-1">{stat?.value}</div>
      <div className="text-sm text-muted-foreground">{stat?.label}</div>
    </div>
  );
};

export default StatsCard;